var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[{ 'content-only' : !_vm.$slots.controls }, 'demo-page-container']},[_c('div',{staticClass:"demo-page-content"},[_vm._t("default")],2),_c('div',{staticClass:"demo-page-controls"},[_vm._t("controls")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }